// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tZJX1{margin:7rem auto}`, "",{"version":3,"sources":["webpack://./src/components/practitionersCarousel/PractitionersCarousel.module.scss"],"names":[],"mappings":"AAAA,OACE,gBAAA","sourcesContent":[".practitionersCarouselWrapper {\n  margin: 7rem auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"practitionersCarouselWrapper": `tZJX1`
};
export default ___CSS_LOADER_EXPORT___;
